import React from 'react';
import * as rsuite from 'rsuite';

const TaskHistory = ({ states }) => {

    if (!states || states.length === 0) {
        return null;
    }

    return (
        <>
            <rsuite.Divider>تاریخچه وضعیت</rsuite.Divider>
            <rsuite.List bordered size="sm">
                {
                    states.map(item => (
                        <rsuite.List.Item key={item.id}>
                            <rsuite.Stack justifyContent="space-between">
                                <span>{item.stateComment}</span>
                                <span>{item.date} - {item.time}</span>
                                <span>{item.userFullName}</span>
                            </rsuite.Stack>
                            {
                                item.comment ?
                                    <div className='text-danger mt-1'>دلیل رد: {item.comment}</div>
                                    :
                                    null
                            }
                        </rsuite.List.Item>
                    ))
                }
            </rsuite.List>
        </>
    );
}

export default TaskHistory;
